import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const getAllLanguagesForPerson = (personId) => dispatch => {
  dispatch({ type: "GET_ALL_LANGUAGES_FOR_PERSON_LOADING" });
  api
    .languagesGetAllForPerson(personId)
    .then(resp => {
      dispatch(operationSucceeded(resp.data));
      dispatch({ type: "GET_ALL_LANGUAGES_FOR_PERSON_LOADING_DONE" });
    })
    .catch(e => {
      jsError(e);
      dispatch({ type: "GET_ALL_LANGUAGES_FOR_PERSON_LOADING_DONE" });
      dispatch(operationFail());
      dispatch(buildAlertWithLocalizedMessages(
        "ERROR",
        "GetAllLanguagesForPersonErrorAlertTitle",
        "Virhe henkilön kielitaitojen haussa",
        e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
    });
};

const operationSucceeded = data => ({
  type: "GET_ALL_LANGUAGES_FOR_PERSON_SUCCEEDED",
  payload: { languages: data },
});

const operationFail = () => ({
  type: "GET_ALL_LANGUAGES_FOR_PERSON_FAIL",
});
